import PropTypes from "prop-types";

import {
  SFGridContainer,
  SFGridItem,
  SFStack,
  SFAvatar,
  SFTypography,
  getStyled,
  getLongDate,
} from "@sf-core";
import { useTranslation } from "react-i18next";

const { styled } = getStyled();

const StyledAvatar = styled(SFAvatar)(({ theme }) => ({
  height: 31.25,
  width: 31.25,
  fontSize: 14,
}));

const DatedAction = ({ user, date, label }) => {
  const { t } = useTranslation();

  if (!user || !date) {
    return null;
  }

  return (
    <SFGridContainer spacing={1}>
      <SFGridItem xs="auto">
        <StyledAvatar name={user} />
      </SFGridItem>
      <SFGridItem xs>
        <SFStack direction="column">
          <SFTypography variant="textLabel">{label}</SFTypography>
          <SFTypography variant="textValue">
            {user}
          </SFTypography>
        </SFStack>
      </SFGridItem>
      <SFGridItem md={12} lg="auto">
        <SFStack direction="column">
          <SFTypography variant="textLabel">{t("datedAction.date")}</SFTypography>
          <SFTypography variant="textValue">
            {getLongDate(date)}
          </SFTypography>
        </SFStack>
      </SFGridItem>
    </SFGridContainer>
  );
};

DatedAction.propTypes = {
  user: PropTypes.string,
  date: PropTypes.string,
  label: PropTypes.string.isRequired,
};

export default DatedAction;
